import { render, staticRenderFns } from "./Addressbook.vue?vue&type=template&id=d635556e&"
import script from "./Addressbook.vue?vue&type=script&lang=js&"
export * from "./Addressbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports